import { render, staticRenderFns } from "./documentComplianceReport.vue?vue&type=template&id=de69aae8&scoped=true"
import script from "./documentComplianceReport.vue?vue&type=script&lang=js"
export * from "./documentComplianceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de69aae8",
  null
  
)

export default component.exports